export const Content = {
  title: 'O firmie',
  content: `Nasza firma powstała w 2009 roku. Od początku swojej działalności nieustannie podnosimy
poziom i jakość naszych usług. Zapewniamy szybkie, bezkolejkowe naprawy z zakresu oferowanych usług.
Służymy radą i gwarantujemy rzetelne doradztwo w zakresie doboru części oraz niezbędnych napraw.
Jesteśmy bardzo konkurencyjni cenowe, przy czym zapewniamy najwyższą jakość usług. Serdecznie zapraszamy do współpracy.`
}

export const Services = {
  title: 'Zakres usług',
  content: [
    'MECHANIKA',
    'DIAGNOSTYKA',
    'WULKANIZACJA',
    'ELEKTRYKA',
    'CZĘŚCI ZAMIENNE',
    'SPRZEDAŻ OPON',
  ]
}
